import { useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { logger } from "@/lib/logger";

/**
 * Configure the native status bar appearance on iOS/Android.
 * Matches the app's dark monochrome design system.
 */
export function useStatusBar() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const configure = async () => {
      try {
        await StatusBar.setStyle({ style: Style.Dark });
        await StatusBar.setBackgroundColor({ color: "#0a0a0a" });
        await StatusBar.setOverlaysWebView({ overlay: false });
      } catch (e) {
        logger.error("status-bar", "Failed to configure status bar:", e);
      }
    };

    configure();
  }, []);
}
